import type { AppMessages } from '../../types';

export const app: AppMessages = {
  common: {
    loading: 'Laster...',
    saving: 'Lagrer...',
    save: 'Lagre',
    back: 'Tilbake',
    error: 'Feil',
    notSet: 'Ikke satt',
    user: 'Bruker',
    system: 'System',
    copied: 'Kopiert!',
    copy: 'Kopier',
    cancel: 'Avbryt',
    creating: 'Oppretter...',
    processing: 'Behandler...',
    you: 'Du',
    stars: 'Stars',
    seeAll: 'Se alle',
    filter: 'Filtrer',
    amount: 'Beløp',
    date: 'Dato',
    details: 'Detaljer',
    mustBeLoggedIn: 'Du må være innlogget',
    daysShort: 'd',
    hoursShort: 't',
    minutesShort: 'min',
    justNow: 'Akkurat nå',
    noTitle: 'Ingen tittel',
    payment: 'betaling',
    payments: 'betalinger',
  },
  layout: {
    dashboard: 'Dashbord',
    invoices: 'Fakturaer',
    ledger: 'Hovedbok',
    withdraws: 'Uttak',
    redirects: 'Omdirigeringer',
    settings: 'Innstillinger',
    admin: 'Admin',
    profile: 'Profil',
    logout: 'Logg ut',
    tonConfigured: 'TON konfigurert',
    configureTon: 'Konfigurer TON',
    tonNotConfigured: 'TON-adresse ikke konfigurert',
    active: 'Aktiv',
    walletConnect: 'Koble til wallet',
    walletTitle: 'Koble til TON-walleten din',
    walletSubtitle: 'Skriv inn TON-adressen som skal motta uttakene dine.',
    walletConnectedTitle: 'Wallet tilkoblet',
    walletConnectedSubtitle: 'Uttakene dine sendes til denne adressen.',
    walletCurrentAddress: 'Tilkoblet adresse',
    walletAddressLabel: 'TON-adresse',
    walletHint: 'User-friendly (EQ… / UQ…) eller raw (0:…) format godtas.',
    walletInvalidAddress: 'Ugyldig TON-adresse',
    walletUpdate: 'Oppdater adresse',
    walletChangeAddress: 'Endre adresse',
    walletDisconnect: 'Koble fra',
    walletDisconnectConfirmTitle: 'Koble fra wallet?',
    walletDisconnectConfirmBody: 'Du kan ikke be om uttak før du kobler til en ny adresse.',
    walletSaved: 'Wallet koblet til',
    walletDisconnected: 'Wallet koblet fra',
    newPaymentLink: 'Ny betalingslenke',
    openBot: 'Telegram-bot',
    helpCenter: 'Hjelpesenter',
  },
  login: {
    seoTitle: 'Logg inn | Telegram Stars betalingsplattform',
    seoDescription: 'Logg inn på Telegram Stars Payment Platform-kontoen din',
    signIn: 'Logg inn',
    signUp: 'Registrer',
    email: 'E-post',
    password: 'Passord',
    displayNameOptional: 'Visningsnavn (valgfritt)',
    displayNamePlaceholder: 'Ditt navn',
    emailPlaceholder: 'din@email.com',
    signInButton: 'Logg inn',
    signUpButton: 'Registrer',
    signInWithGoogle: 'Logg inn med Google',
    or: 'ELLER',
    welcome: 'Velkommen',
    subtitle: 'Logg inn eller opprett en konto for å komme i gang',
    minPasswordHint: 'Minimum 6 tegn',
    tipTelegram: '💡 Tips: du kan koble Telegram-kontoen din i innstillingene etter registrering',
    continueWithTelegram: 'Fortsett med Telegram',
    telegramAuthError: 'Telegram-innlogging mislyktes. Prøv igjen.',
    featureInstant: 'Umiddelbar kontoopprettelse',
    featureManage: 'Administrer Telegram Stars-betalingene dine',
    featureWithdraw: 'Ta ut midlene dine til TON',
    emailRequired: 'Skriv inn e-postadressen din',
    emailInvalid: 'Ugyldig e-postformat',
    passwordRequired: 'Skriv inn passordet ditt',
    passwordRequiredSignup: 'Skriv inn et passord',
    passwordMinLength: 'Passordet må inneholde minst 6 tegn',
    genericError: 'Det oppstod en feil',
    recaptchaFailed: 'reCAPTCHA-verifisering mislyktes. Prøv igjen.',
    invalidCredentials: 'Feil e-post eller passord. Hvis du ikke har en konto ennå, opprett en i fanen «Registrer».',
    wrongPassword: 'Feil passord. Sjekk passordet ditt.',
    tooManyAttempts: 'For mange forsøk. Prøv igjen senere.',
    accountDisabled: 'Denne kontoen er deaktivert. Kontakt support.',
    authNotEnabled: 'E-post/passord-autentisering er ikke aktivert. Sjekk Firebase-konfigurasjonen.',
    emailInUse: 'Denne e-posten er allerede i bruk. Logg inn med denne e-posten.',
    googleAuthError: 'Det oppstod en feil under Google-autentisering',
    popupClosed: 'Popup-vinduet ble lukket. Prøv igjen.',
    popupBlocked: 'Popup-vinduet ble blokkert. Tillat popups og prøv igjen.',
    popupCancelled: 'Kun én popup-forespørsel er tillatt om gangen.',
  },
  dashboard: {
    loading: 'Laster dashbord...',
    overallSummary: 'Samlet oversikt',
    lastMonth: 'Forrige måned',
    lastWeek: 'Forrige uke',
    lastYear: 'I fjor',
    balance: 'Saldo',
    available: 'Tilgjengelig',
    totalEarned: 'Totalt opptjent',
    fromLastMonth: 'sammenlignet med forrige måned',
    recentPayments: 'Nylige betalinger',
    last7days: 'Siste 7 dager',
    last30days: 'Siste 30 dager',
    quickActions: 'Hurtighandlinger',
    createLink: 'Opprett lenke',
    createLinkDesc: 'Generer en ny betalingslenke',
    withdraw: 'Ta ut',
    withdrawDesc: 'Ta ut Stars til TON',
    invoices: 'Fakturaer',
    invoicesDesc: 'Se betalingshistorikk',
    ledger: 'Hovedbok',
    ledgerDesc: 'Se alle transaksjoner',
    recentActivity: 'Nylig aktivitet',
    noRecentActivity: 'Ingen nylig aktivitet',
    mostRecent: 'Nyeste',
    noRecentInvoices: 'Ingen nylige fakturaer',
    allInvoices: 'Alle fakturaer',
    paymentReceived: 'Betaling mottatt: {title}',
    withdrawalRequested: 'Uttak forespurt: {amount} {suffix}',
    transaction: 'Transaksjon: {amount} {suffix}',
    invoiceLabel: 'Faktura #{id}',
    failedLoadBalance: 'Kunne ikke laste saldo',
    chartAmount: 'Beløp',
  },
  invoices: {
    loading: 'Laster...',
    allInvoices: 'Alle fakturaer',
    paid: 'Betalt',
    sent: 'Sendt',
    created: 'Opprettet',
    expired: 'Utløpt',
    filter: 'Filtrer',
    createInvoice: '+ Opprett faktura',
    noInvoices: 'Ingen fakturaer funnet',
    relatedTo: 'Relatert til:',
    paymentMode: '{mode}-betaling',
    copyLink: 'Kopier lenke',
    copyLinkTitle: 'Kopier fakturalenke',
    linkNotAvailable: 'Fakturalenke ikke tilgjengelig',
    linkCopied: 'Fakturalenke kopiert til utklippstavlen!',
    copyFailed: 'Kunne ikke kopiere lenke',
    failedLoad: 'Kunne ikke laste fakturaer',
    statusPaid: 'betalt',
    statusSent: 'sendt',
    statusCreated: 'opprettet',
    statusExpired: 'utløpt',
    typeSingleUse: 'engangs',
    typeRecurring: 'gjentakende',
  },
  createInvoice: {
    back: 'Tilbake',
    title: 'Opprett en betalingslenke',
    subtitle: 'Generer en ny betalingslenke på sekunder',
    successTitle: 'Betalingslenke opprettet!',
    successSubtitle: 'Betalingslenken din er klar til deling',
    paymentLink: 'Betalingslenke:',
    integrationTitle: 'Integrer denne lenken på nettstedet ditt',
    integrationDesc: 'Telegram-botten vår veileder deg trinn for trinn (API, HTML-knapp, omdirigeringer).',
    openTutorial: 'Åpne veiledning',
    testLink: 'Test lenke',
    viewInvoices: 'Se fakturaene mine',
    createNew: 'Opprett en ny lenke',
    shareTelegram: 'Del på Telegram',
    paymentMode: 'Betalingsmodus',
    modeStars: 'Stars',
    modeEur: 'EUR (€)',
    modeUsd: 'USD ($)',
    amountInteger: 'Beløp (heltall)',
    amountDecimal: 'Beløp (desimal)',
    amountRequired: 'Skriv inn et beløp',
    amountIntegerError: 'Beløpet må være et heltall større enn 0',
    amountNoDecimals: 'Stars-beløp må være et heltall (ingen desimaler)',
    amountMustBeInteger: 'Stars-beløp må være et heltall',
    amountGreaterThanZero: 'Beløpet må være større enn 0',
    titleOptional: 'Tittel (valgfritt)',
    titlePlaceholder: 'Betalingstittel (f.eks. Betaling for tjenester)',
    descriptionOptional: 'Beskrivelse (valgfritt)',
    descriptionPlaceholder: 'Detaljert betalingsbeskrivelse...',
    singleUse: 'Engangs-lenke',
    singleUseTooltip: 'Hvis aktivert, kan denne lenken bare brukes én gang. Etter betaling blir den ugyldig.',
    createLink: 'Opprett lenke',
    cancel: 'Avbryt',
    invalidAmount: 'Ugyldig beløp',
    starsMustBeInteger: 'Beløpet må være et heltall for Stars',
    createError: 'Feil ved opprettelse av faktura',
  },
  ledger: {
    title: 'Hovedbok',
    typeColumn: 'Type',
    description: 'Fullstendig historikk over alle transaksjonene dine',
    loading: 'Laster...',
    noEntries: 'Ingen transaksjoner for øyeblikket.',
    typePayment: 'Betaling',
    typeFee: 'Gebyr',
    typeNetPayment: 'Nettobetaling',
    typeWithdrawal: 'Uttak',
    typeAdjustment: 'Justering',
    amountStars: 'Beløp (Stars)',
    invoiceDetail: 'Faktura: {title} ({amount} Stars)',
    paidBy: 'Betalt av: {payer}',
    payerId: '(ID: {id})',
    withdrawDetail: 'Uttak: {amount} Stars (Status: {status})',
    failedLoad: 'Kunne ikke laste hovedbok',
  },
  withdraws: {
    title: 'Mine uttaksforespørsler',
    newRequest: '+ Ny forespørsel',
    totalLedger: 'Totalt hovedbok',
    available: 'Tilgjengelig',
    pendingWithdrawals: 'Ventende uttak',
    hold21days: '21 dagers sperre',
    payoutNote: 'Utbetalinger behandles manuelt av en admin. Et gebyr på 3% gjelder ved uttak.',
    forecastTitle: 'Uttaksprognose',
    loadingForecast: 'Laster prognose...',
    noForecast: 'Ingen kommende uttaksdatoer',
    paymentsCount: '({count} betalinger)',
    noRequests: 'Ingen uttaksforespørsler for øyeblikket.',
    createFirst: 'Opprett din første forespørsel',
    amount: 'Beløp:',
    destination: 'Destinasjon:',
    processedOn: 'Behandlet:',
    externalRef: 'Ekstern referanse:',
    errorLabel: 'Feil:',
    rejectionReason: 'Avvisningsgrunn:',
    failedLoad: 'Kunne ikke laste uttak',
    loading: 'Laster...',
  },
  createWithdraw: {
    title: 'Be om uttak',
    balanceSource: 'Saldo (kilde: backend-hovedbok)',
    available: 'Tilgjengelig: {amount} Stars',
    pending: 'Ventende uttak: {amount} Stars',
    waiting: '21 dagers sperre: {amount} Stars',
    minAndFee: 'Minimum uttak: {min} Stars · Plattformgebyr: 3% ved utbetaling (manuell behandling)',
    amountLabel: 'Beløp (Stars)',
    minPlaceholder: 'Minimum: {min}',
    feeHint: 'Brutto: {gross} Stars · Gebyr (3%): {fee} Stars · Du mottar: {net} Stars',
    useRegistered: 'Bruk min registrerte TON-adresse',
    registeredAddress: 'Registrert adresse:',
    tonDestination: 'TON destinasjonsadresse',
    tonPlaceholder: 'EQAbc123...',
    tonFormatHint: 'Format: EQ... eller 0:... (base64 eller hex)',
    createRequest: 'Opprett forespørsel',
    cancel: 'Avbryt',
    creating: 'Oppretter...',
    insufficientBalance: '⚠️ Utilstrekkelig saldo for uttak (minimum: {min} Stars)',
    amountMustBeInteger: 'Beløpet må være et positivt heltall',
    createError: 'Feil ved opprettelse av uttaksforespørsel',
  },
  redirects: {
    title: 'Omdirigeringslenker',
    description: 'Opprett korte lenker som omdirigerer til en URL du velger. Deling av lenken /r/din-slug sender besøkende til den konfigurerte URL-en.',
    newRedirect: 'Ny omdirigering',
    clicks: 'klikk',
    unique: 'unike',
    links: 'lenker',
    modalTitle: 'Ny omdirigering',
    slugLabel: 'Slug (lenke-ID)',
    slugRequired: 'Obligatorisk felt',
    slugPattern: 'Kun bokstaver, tall, bindestreker og understreker',
    slugMax: 'Maks 64 tegn',
    slugReserved: 'Denne slug-en er reservert. Velg en annen.',
    slugPlaceholder: 'f.eks.: min-side',
    urlLabel: 'Destinasjons-URL',
    urlInvalid: 'Ugyldig URL',
    urlHttpOnly: 'Kun http- og https-URL-er aksepteres.',
    urlTooLong: 'URL for lang (maks 2048 tegn).',
    urlPlaceholder: 'https://example.com/page',
    createButton: 'Opprett omdirigering',
    loading: 'Laster…',
    empty: 'Ingen omdirigeringer. Klikk «Ny omdirigering» for å opprette en.',
    copyLink: 'Kopier lenke',
    linkCopied: 'Lenke kopiert',
    deleteTitle: 'Slette denne omdirigeringen?',
    yes: 'Ja',
    no: 'Nei',
    delete: 'Slett',
    totalClicks: 'Totalt klikk',
    uniqueClicks: 'Unike klikk',
    avgClicks: 'Snitt klikk/besøkende',
    loadError: 'Feil ved lasting av omdirigeringer',
    createSuccess: 'Omdirigeringslenke opprettet',
    createError: 'Feil ved opprettelse av omdirigering',
    deleteSuccess: 'Omdirigering slettet',
    deleteError: 'Feil ved sletting av omdirigering',
  },
  adminWithdraws: {
    title: 'Administrasjon - Uttaksforespørsler',
    filterByStatus: 'Filtrer etter status:',
    all: 'Alle',
    noRequests: 'Ingen forespørsler for denne statusen.',
    agent: 'Agent:',
    amount: 'Beløp:',
    destination: 'Destinasjon:',
    processedOn: 'Behandlet:',
    externalRef: 'Ekst. ref.:',
    errorLabel: 'Feil:',
    reason: 'Grunn:',
    approve: '✓ Godkjenn',
    reject: '✗ Avvis',
    markPaid: '✓ Merk betalt',
    markFailed: '✗ Merk mislykket',
    approveConfirm: 'Godkjenne denne uttaksforespørselen?',
    rejectPrompt: 'Avvisningsgrunn:',
    markPaidPrompt: 'Ekstern utbetalingsreferanse (påkrevd — TON tx-hash, bankref., etc.):',
    markPaidRequired: 'externalRef er påkrevd for å bekrefte manuell utbetaling.',
    markFailedPrompt: 'Feilmelding:',
    approveError: 'Feil ved godkjenning av uttak',
    rejectError: 'Feil ved avvisning av uttak',
    updateError: 'Feil ved oppdatering',
    failedLoad: 'Kunne ikke laste uttak',
    notAuthenticated: 'Ikke autentisert',
    operationFailed: 'Operasjonen mislyktes',
    loading: 'Laster...',
  },
  redirectResolve: {
    missingSlug: 'Slug mangler',
    invalidLink: 'Ugyldig lenke',
    notFound: 'Lenke ikke funnet',
    notFoundTitle: 'Lenke ikke funnet',
    redirecting: 'Omdirigerer...',
    redirectTitle: 'Omdirigering',
  },
  errorBoundary: {
    title: 'Det oppstod en feil',
    subtitle: 'Beklager, noe gikk galt. Prøv igjen.',
    goHome: 'Tilbake til forsiden',
    reload: 'Last siden på nytt',
    devDetails: 'Feildetaljer (kun dev):',
  },
};

export const settingsApp = {
  eyebrow: 'INNSTILLINGER',
  profile: 'Profil',
  email: 'E-post',
  telegramId: 'Telegram-ID',
  notLinked: 'Ikke koblet',
  linking: 'Kobler...',
  linkTelegram: 'Koble Telegram-kontoen min',
  openFromTelegram: '⚠️ Åpne denne siden fra Telegram for å koble kontoen din',
  displayName: 'Visningsnavn',
  displayNameHint: 'Visningsnavn settes ved opprettelse av konto',
  withdrawal: 'Uttak',
  tonAddress: 'TON destinasjonsadresse',
  tonAddressPlaceholder: 'EQAbc123... eller 0:...',
  tonAddressHint: 'Denne adressen brukes som standard for uttakene dine',
  tonUpdated: 'TON-adresse oppdatert',
  about: 'Om',
  commission: 'Plattformgebyr:',
  commissionValue: '3% på hver betaling',
  minWithdrawal: 'Minimum uttak:',
  minWithdrawalValue: '100 Stars',
  starsCurrency: 'Stars-valuta:',
  starsCurrencyValue: 'XTR',
  telegramWebAppNotAvailable: 'Telegram WebApp ikke tilgjengelig. Åpne denne siden fra Telegram.',
  telegramUserDataNotAvailable: 'Telegram-brukerdata ikke tilgjengelig.',
  telegramLinked: 'Telegram-konto koblet!',
  linkTelegramError: 'Feil ved kobling av Telegram-konto',
  updateError: 'Feil ved oppdatering',
  mustBeLoggedIn: 'Du må være innlogget',
};
